module.exports = __webpack_public_path__ + "img/header-22.6984624.png";